import classNames from 'classnames'
import { z } from 'zod'
import * as styles from './count-badge.css.ts'

export const CountBadgeVariantSchema = z.enum(['default', 'muted'])
export type CountBadgeVariant = z.infer<typeof CountBadgeVariantSchema>

export type CountBadgeProps = {
  count: number
  /** Defaults to `muted` for zero, so an empty count recedes without every caller deciding that. */
  variant?: CountBadgeVariant
  className?: string
  'aria-label'?: string
}

/** A small pill carrying a count — beside a tab label, or leading a list of the things counted. */
export const CountBadge: React.FC<CountBadgeProps> = ({
  count,
  variant = count === 0 ? 'muted' : 'default',
  className,
  'aria-label': ariaLabel,
}) => (
  <span className={classNames(styles.badge[variant], className)} aria-label={ariaLabel}>
    {count}
  </span>
)
